import PayPanel from './PayPanel'

export default PayPanel
